import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Bande from '../components/Bande';
import SectionContact from '../components/SectionContact';
import Faq from '../components/Faq';
import Avis from '../components/Avis';
import { ENTREPRISE, FAQ } from '../data/site';

export default function Contact() {
  return (
    <>
      <Seo
        titre="Demander un devis | BATI SELECT TP Alfortville"
        description="Demandez votre devis de location d'engins de chantier à Alfortville (94). Réponse en quelques heures, livraison en Île-de-France sous 24 à 48 h."
      />

      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-14 sm:py-16">
          <h1 className="font-display uppercase text-[36px] sm:text-[48px] leading-[1] max-w-3xl">
            Parlez-nous de votre <span className="mot-degrade">chantier</span>
          </h1>
          <p className="mt-5 text-white/75 max-w-2xl text-[18px]">
            Devis gratuit, réponse en quelques heures. Dites-nous la machine, les dates
            et la commune du chantier, on s'occupe du reste.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a href={ENTREPRISE.telephoneLien} className="btn-jaune">
              Appeler le {ENTREPRISE.telephone}
            </a>
            <Link to="/nos-engins" className="btn-contour">Voir le parc</Link>
          </div>
        </div>
        <Bande hauteur={6} />
      </section>

      <SectionContact
        avant="Le formulaire, en deux "
        mot="minutes"
        intro="Plus vous êtes précis sur l'accès et sur les dates, plus notre réponse est utile. Si votre chantier démarre demain, appelez-nous plutôt que d'écrire."
      />

      <Avis />

      <Faq />
    </>
  );
}
